import type { Route } from '~/core/router'

import * as root from '~/routes/events/root'

// TODO: At present time requests has happened on every tab click, even if clicked the same tab
export const route: Route = {
  children: [
    {
      path: '',
      component: [root.Title, root.LiveEventsPage],
      init: root.model.initAllEventsPage,
      left: root.model.leftAllEventsPage,
    },
  ],
}
